// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Inbox from './pages/Inbox';
import Sent from './pages/Sent';
import Drafts from './pages/Drafts';
import Trash from './pages/Trash';
import Compose from './pages/Compose';

function PrivateRoute({ children }) {
    const { token } = useAuth();
    return token ? children : <Navigate to="/login" />;
}

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={
                        <PrivateRoute>
                            <Layout />
                        </PrivateRoute>
                    }>
                        <Route index element={<Navigate to="/inbox" />} />
                        <Route path="inbox" element={<Inbox />} />
                        <Route path="sent" element={<Sent />} />
                        <Route path="drafts" element={<Drafts />} />
                        <Route path="trash" element={<Trash />} />
                        <Route path="compose" element={<Compose />} />
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;